export default {
  title: '{{company}} updated your pickup time',
  title_on_site: '{{company}} updated when your order is served',
  new_time_label: 'New time',
};
